<template>
  <div class="MusicPlaylist" v-if="playlist">
    <el-table
        height="600"
        ref="filterTable"
        :data="playlist"
        class="table">

      <el-table-column
          prop="music_name"
          label="Name"
          width="250">
      </el-table-column>

      <el-table-column
          prop="music_author"
          label="Author"
          width="250">
      </el-table-column>

      <el-table-column
          prop="album_name"
          label="Album Name"
          width="150"
          :filters="album_list"
          :filter-method="filterTag"
          filter-placement="bottom-end">
        <template slot-scope="scope">
          <el-tag size="medium">{{ scope.row.album_name }}</el-tag>
        </template>
      </el-table-column>

      <!--      <el-table-column-->
      <!--          prop="music_image"-->
      <!--          label="Thumbnail"-->
      <!--          width="250">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-image lazy :src="scope.row.music_image" style="width:220px;height: 120px" fit="contain"></el-image>-->
      <!--        </template>-->
      <!--      </el-table-column>-->

      <el-table-column label="">
        <template slot-scope="scope">
          <el-button
              size="mini"
              style="width: 70px"
              @click="onEdit(scope.row.music_name,scope.row.music_author,scope.row.aid,scope.row.music_id,scope.row.music_image,scope.row.music_file)">
            Edit
          </el-button>
          <el-button
              size="mini"
              style="width: 70px"
              type="danger"
              @click="onDelete(scope.row.music_id)">Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-button @click="dialog_visible = true" class="add" type="primary" size="medium" round="" icon="el-icon-plus">
      Upload Music
    </el-button>
    <el-dialog width="35%" style="min-width: 1400px" title="Album" :visible.sync="dialog_visible">
      <div v-if="dialog_visible">
        <el-form v-if="dialog_visible" :model="item_holder" :rules="rules" ref="nameForm">
          <el-form-item label="Name" label-width="100px" prop="name">
            <el-input v-model="item_holder.name" style="width: 300px" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Author" label-width="100px" prop="author">
            <el-input v-model="item_holder.author" style="width: 300px" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Album" label-width="100px" prop="album">
            <el-select v-model="item_holder.album" placeholder="Select Album">
              <el-option
                  v-for="item in album_list"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Thumbnail" label-width="100px" prop="image">
            <ImageUpload style="max-width: 150px;overflow: hidden"
                         :limit="1" target="banner" :input="current_input"
                         @output="onUpdateImage"></ImageUpload>
          </el-form-item>
          <el-form-item label="Music File" label-width="100px" prop="audio">
            <AudioUpload style="margin-bottom: 20px" :input="current_audio"
                         @remove="onRemoveAudio" @output="onUpdateAudio"></AudioUpload>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="item_holder.image===''||item_holder.audio===''"
                     @click="onSave(item_holder.name,item_holder.author,item_holder.album,item_holder.id,item_holder.image,item_holder.audio)">
            Save
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {deletePlaylist, getAlbumList, getPlaylist, savePlaylist} from "@/utils/api";
  import ImageUpload from "@/components/Images/Images";
  import AudioUpload from "@/components/Audios/Audios";

  export default {
    props: {},
    components: {
      ImageUpload,
      AudioUpload
    },
    data: () => {
      return {
        playlist: false,
        album_list: [],
        dialog_visible: false,
        current_input: [],
        current_audio: '',
        item_holder: {
          name: '',
          author: '',
          album: '',
          id: '',
          image: '',
          audio: ''
        },
        rules: {
          name: [
            {required: true, message: 'Music name is required', trigger: 'blur'},
          ],
          author: [
            {required: true, message: 'Music author is required', trigger: 'blur'},
          ],
          album: [
            {required: true, message: 'Album is required', trigger: 'blur'},
          ],
          image: [
            {required: true, message: 'Thumbnail is required', trigger: 'blur'},
          ],
          audio: [
            {required: true, message: 'Music file is required', trigger: 'blur'},
          ],
        }
      }
    },
    watch: {
      dialog_visible: function (n) {
        if (!n) {
          this.item_holder = {
            name: '',
            author: '',
            album: '',
            id: '',
            image: '',
            audio: ''
          };
          this.onRefresh()
        }
      },
    },
    methods: {
      onUpdateImage(e) {
        if (e.image_list.length === 0) {
          this.item_holder.image = ''
        } else {
          this.item_holder.image = e.image_list[0]
        }
      },
      onUpdateAudio(e) {
        this.item_holder.audio = e.audio_path;
      },
      onRemoveAudio() {
        this.item_holder.audio = '';
      },
      onEdit(name, author, album, id, image, audio) {
        this.item_holder = {
          name: name,
          author: author,
          album: album,
          id: id,
          image: image,
          audio: audio
        };
        this.dialog_visible = true;
        setTimeout(() => {
          this.current_input = [image];
          this.current_audio = audio
        })
      },
      onDelete(id) {
        this.$confirm(`Are you sure to delete this music file?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deletePlaylist(id).then(res => {
            if (res.errcode === 0) {
              this.$message.success('Music file deleted');
              this.onRefresh()
            } else {
              this.$message.error('Error');
            }
          })
        }).catch(() => {
        });
      },
      onSave(name, author,album_id, id, image_path, audio_path) {
        this.$refs['nameForm'].validate((valid) => {
          if (valid) {
            savePlaylist(name, author,album_id, id, image_path, audio_path).then(res => {
              if (res.errcode === 0) {
                this.$message.success(`Music ${id === '' ? 'created' : 'saved'}`);
              } else {
                this.$message.error('Error');
              }
              this.dialog_visible = false
            })
          } else {
            this.$message.error('Check your inputs');
            return false;
          }
        });
      },
      filterTag(value, row) {
        return row.aid === value;
      },
      onRefresh() {
        this.$showLoading('Loading');
        getPlaylist().then(res => {
          this.$hideLoading();
          this.playlist = res.playlist
        });
        getAlbumList().then(res => {
          let album_list = [];
          res.album_list.forEach(v => {
            album_list.push({
              value: v.album_id,
              text: v.album_name
            })
          });
          this.album_list = album_list
        })
      }
    },
    beforeMount() {
      this.onRefresh()
    },
  };

</script>

<style lang="scss" scoped>
  @import "_MusicPlaylist.scss";
</style>